module.exports = __webpack_public_path__ + "static/media/trumpet.89ba99ae.svg";